/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  function spinnerIn() {
    setTimeout(function(){$(".spinner").addClass("in");}, 0);
  }

  function iconMenu() {
    $('.nav-icon-mobile').on('click', function(){
      $(this).toggleClass('menu-open');
    });

    $('.menu-item').on('click', function(){

      if($('.nav-icon-mobile').is(":visible"))
      {
        $('.nav-icon-mobile').click();
      }
    });
  }

  function initGoodbye()
  {



    $(window).on('hashchange', function(e){


      var hash = window.location.hash;
      var url = '/';
      if(hash != '')
      {
        url = hash.replace('#', '');
      }

      loadPage(url);
    });




    $('body').on('click', 'a.brand,.goodbye a', function(e){
      e.preventDefault();
      e.stopPropagation();

      var link = $(this);
      var href = $(this).prop('href');


      var tab = e.metaKey;
      if(tab)
      {
        window.open(href);
      }
      else {

        var parent = $(this).parent();

        if(parent.hasClass('menu-item'))
        {
          if($('.nav-icon-mobile').is(":visible"))
          {
            $('.navbar-toggle').addClass('collapsed');
            $('.navbar-toggle').removeClass('menu-open');
            $('.navbar-toggle').attr('aria-expanded', 'false');
            $('.navbar-collapse').collapse('hide');
          }
        }


        var pattern = new RegExp('(http[s]?:\/\/)?[a-zA-Z0-9\-]*.[a-zA-Z0-9\-]*.[a-zA-Z0-9\-]*([^ ]*)');
        var url = href.replace(pattern, '$2');
        var currentHash = window.location.hash;
        var currentUrl = '/';

        if(currentHash != '')
        {
          currentUrl = currentHash.replace('#', '');
        }



        $('.modal-backdrop.welcome-backdrop').css({top: 81, bottom: 81 });

        $('body').addClass('welcome goodbye');

        setTimeout(function(){


          window.location.hash = url;



          if(url == currentUrl)
          {
            $(window).trigger('hashchange');
          }



        }, 500);


        //$('.modal-backdrop.welcome-backdrop').one(transitionEvent, function(){
        //  window.location.href = href;
        //});
      }
    });
  }


  function loadPage(url)
  {
    $('.ajax-loaded').load(url + ' .wrap.container-fluid', null,
      function (responseText, textStatus, XMLHttpRequest) {


        $('.wrap.container-fluid:first').html($('.ajax-loaded .wrap.container-fluid').html());


        $('.ajax-loaded').html('');


        var parser = new DOMParser();
        doc = parser.parseFromString(responseText, "text/html");
        // Your class(es)
        var docClass = doc.body.getAttribute('class');
        // Garbage collection, you don't need this anymore.
        parser = doc = null;

        $('body').attr('class', docClass);

        $('#bs-example-navbar-collapse-1').html($('#bs-example-navbar-collapse-1', responseText).html())


        //if(parent)
        //{
        //  if(parent.hasClass('menu-item'))
        //  {
        //    $('.menu-item').removeClass('current-menu-item current_page_item');
        //    parent.addClass('current-menu-item');
        //    parent.addClass('current_page_item');
        //
        //    link.blur();
        //  }
        //  else if(link.hasClass('brand'))
        //  {
        //    $('.menu-item').removeClass('current-menu-item current_page_item');
        //    $('.menu-item:first').addClass('current-menu-item');
        //    $('.menu-item:first').addClass('current_page_item');
        //
        //    link.blur();
        //  }
        //}


        $('.wrap.container-fluid .wp-playlist').each( function() {
          return new WPPlaylistView({ el: this });
        } );

        slickInitialize();

        modalVideo();
        equalHeight();

        easyload();

        setTimeout(function(){
          equalHeight();
        }, 200);

        $("body").removeClass("welcome");
        setTimeout(function(){
          $('.modal-backdrop.welcome-backdrop').css({top: '-100%', bottom: 'auto'});

          pageShown = false;

        }, 1000);


      }
    );
  }

  var vimeoPlayer = null;
  var youtubePlayer = null;
  var activeVideo = false;

  function modalVideo() {

    $('.cover-item, .big-cover-item, .slide-video').on('click', function(e){
      e.preventDefault();

      $(this).addClass('modal-active');

      var thumb = $(this);
      var videoID = thumb.data('video');
      var provider = thumb.data('provider');
      var embedURL = '';


      if(provider == 'youtube')
      {
        embedURL = 'https://www.youtube.com/embed/' + videoID;

        //$('#modal-video .embed-responsive-16by9').html('<iframe class="embed-responsive-item" src="'+embedURL+'" frameborder="0" allowfullscreen id="youtube-player"></iframe>');


        if(activeVideo != videoID)
        {
          if(youtubePlayer)
          {
            youtubePlayer.destroy();
            youtubePlayer = null;
          }


          youtubePlayer = new YT.Player('player-container', {
            height: '390',
            width: '640',
            videoId: videoID,
            //origin:
            playerVars: { 'autoplay': 1},
            //events: {
            //  'onReady': onPlayerReady,
            //}
          });
        }
        else {
          youtubePlayer.playVideo();
        }

        $('#modal-video').one('hide.bs.modal', function(){
          if(youtubePlayer)
          {
            youtubePlayer.pauseVideo();
          }
        });

      }
      else if(provider == 'vimeo')
      {
        embedURL = 'https://player.vimeo.com/video/' + videoID + '?title=0&byline=0&portrait=0';

        $('#modal-video .embed-responsive-16by9').html('<iframe class="embed-responsive-item" src="'+embedURL+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
      }


      activeVideo = videoID;

      $('#modal-video').modal('show');


    });
    $('#modal-video').on('shown.bs.modal', function() {
      $('.coverflow').slick('slickPause');
      $('.slideshow').slick('slickPause');
    });
    $('#modal-video').on('hidden.bs.modal', function() {
      $('.coverflow').slick('slickPlay');
      $('.slideshow').slick('slickPlay');
      $('.cover-item').removeClass('modal-active');
    });

  }


  function whichTransitionEvent(){
    var t,
      el = document.createElement("fakeelement");

    var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    }

    for (t in transitions){
      if (el.style[t] !== undefined){
        return transitions[t];
      }
    }
  }


  function slickInitialize() {
    $('.slideshow').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      speed: 1000,
      fade: true,
      cssEase: 'ease',
      pauseOnHover: false,
      mobileFirst: true
    });

    $('.coverflow').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      dots:false,
      arrows: false,
      infinite: true,
      centerMode: true,
      variableWidth: true,
      speed: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      cssEase: 'ease',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 2400,
          settings: {
            slidesToShow: 12,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          }
        },
        {
          breakpoint: 2200,
          settings: {
            slidesToShow: 10,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          }
        },
        {
          breakpoint: 1719,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          }
        },
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          }
        },

        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          }
        },
        {
          breakpoint: 800,
          settings: {
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 440,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    function welcome() {
      $("body").removeClass("welcome");
      setTimeout(function(){
        $('.modal-backdrop.welcome-backdrop').css({top: '-100%', bottom: 'auto'});

        pageShown = false;

      }, 1000);
    };

    function setModalMaxHeight(element) {
      this.$element     = $(element);
      this.$content     = this.$element.find('.modal-content');
      var borderWidth   = this.$content.outerHeight() - this.$content.innerHeight();
      var dialogMargin  = $(window).width() < 768 ? 20 : 60;
      var contentHeight = $(window).height() - (dialogMargin + borderWidth);
      var headerHeight  = this.$element.find('.modal-header').outerHeight() || 0;
      var footerHeight  = this.$element.find('.modal-footer').outerHeight() || 0;
      var maxHeight     = contentHeight - (headerHeight + footerHeight);

      this.$content.css({
        'overflow': 'hidden'
      });

      this.$element
        .find('.modal-body').css({
        'max-height': maxHeight,
        'overflow-y': 'auto'
      });
    }

    $('.modal').on('show.bs.modal', function() {
      $(this).show();
      setModalMaxHeight(this);
    });

    $(window).on('resize',function() {
      if ($('.modal.in').length !== 0) {
        setModalMaxHeight($('.modal.in'));
      }
    });
    $(window).on('load', function(){
      welcome();
    });





    if (screen.width < 400) {
      var regex = new RegExp('Googlebot');
      if(navigator.userAgent.match(regex) == null)
      {
        $("#viewport").attr("content", "width=400, maximum-scale=1, user-scalable=no");
      }
    }

  }


  function equalHeight() {
    var wWidth = $(window).width();
    if($('.equal').length && wWidth >= 768)
    {
      $('.equal').each(function(){
        var maxHeight = 0;

        $(this).children().attr('style', '');
        $.each($(this).children(), function(){

          if($(this).outerHeight() > maxHeight)
          {
            maxHeight = $(this).outerHeight();
          }
        });
        $(this).children().css('height', maxHeight);
      });
    }
  }








  function setContactForm()
  {
    var contact_form = jQuery('.contact-form');

    if(contact_form.length)
    {
      contact_form.on('submit', function(e){
        e.preventDefault();
        doContactFormValidation(contact_form);
      });
    }
  }

  var CONTACT_FORM_NOT_SENT = 'Warning!';
  var CONTACT_FORM_SENT = 'Your message was sent successfully. Thanks !';
  var CONTACT_FORM_ERROR = 'Please fill in all fields';
  var CONTACT_FORM_ERROR_EMAIL = 'Invalid e-mail address';

  function doContactFormValidation(form)
  {
    var error = false;
    var messages = {};
    var inputs = {
      'name' : jQuery('#name', form),
      'email' : jQuery('#email', form),
      'subject' : jQuery('#subject', form),
      'message' : jQuery('#message', form),
    };
    var values = {};

    jQuery.each(inputs, function(input_name, input){

      var value = input.val();

      values[input_name] = value;

      if(value == '')
      {
        error = true;
        addContactFormError(form, input);
        messages['empty'] = CONTACT_FORM_ERROR;
      }
      else {

        if(input_name == 'email' && validEmailAddress(value) == false)
        {
          error = true;
          addContactFormError(form, input);
          messages['email'] = CONTACT_FORM_ERROR_EMAIL;
        }
        else {
          removeContactFormError(form, input);
        }
      }
    });

    if(error)
    {
      addContactFormErrorMessage(form, messages);
    }
    else {
      saveContactForm(values, form);
    }
  }

  function saveContactForm(values, form)
  {
    jQuery('.messages', form).html('');

    jQuery.post(
      '/wp-admin/admin-ajax.php',
      {
        'action' : 'contact_save',
        'values' : values,
      },
      function(data)
      {
        if(data.success)
        {
          addContactFormSuccessMessage(form);
        }
        else {
          messages = ['An error has occurred. Please try again later.'];
          addContactFormErrorMessage(form, messages);
        }
      },
      'json'
    ).error(function(){
      messages = ['An error has occurred. Please try again later.'];
      addContactFormErrorMessage(form, messages);
    });
  }

  function addContactFormError(form, input)
  {
    input.addClass('error');
  }
  function removeContactFormError(form, input)
  {
    input.removeClass('error');
  }

  function addContactFormSuccessMessage(form)
  {
    jQuery('.messages', form).html('');

    jQuery('#name', form).val('');
    jQuery('#email', form).val('');
    jQuery('#message', form).val('');
    jQuery('#subject', form).val('');

    var error_alert = jQuery('<span class=""><i class="icon icon-check"></i>&nbsp;</span>');
    var error_alert_type = jQuery('<strong>').text(CONTACT_FORM_SENT);

    error_alert.append(error_alert_type);

    $('.messages', form).html(error_alert);
  }

  function addContactFormErrorMessage(form, messages)
  {
    jQuery('.messages', form).html('');

    var error_alert = jQuery('<span class="error"><i class="icon icon-exclamation-triangle"></i>&nbsp;</span>');
    var error_alert_type = jQuery('<strong>').text(CONTACT_FORM_NOT_SENT);

    error_alert.append(error_alert_type);

    jQuery.each(messages, function(i, message){
      error_alert.append('<br>' + message);
    });

    $('.messages', form).html(error_alert);
  }

  function validEmailAddress(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }









  function easyload()
  {
    var windowsWidth = $(window).width();

    $.each($('.slide-cover'), function(){
      var slide = $(this);

      var full = slide.data('full');
      var large = slide.data('large');

      var hightRes = large;

      if(windowsWidth > 1024 || (windowsWidth > 512 && (isRetina() || isHighDensity() ) ) )
      {
        if(full != 'undefined')
        {
          hightRes = full;
        }
      }


      if(typeof hightRes != 'undefined')
      {
        var tempImg = new Image();

        $(tempImg).load(function(){
          slide.css('background-image', 'url(' + hightRes + ')');
        });

        tempImg.src = hightRes;
      }
    });

    $.each($('.retina-image'), function(){
      var image = $(this);

      var large = image.data('large');




      if(typeof large != 'undefined' && (isRetina() || isHighDensity()))
      {
        var tempImg = new Image();

        $(tempImg).load(function(){
          image.attr('src', large);
        });

        tempImg.src = large;
      }
    });
  }














  // Load Events
  $(document).ready(UTIL.loadEvents);

  transitionEvent = whichTransitionEvent();

  spinnerIn();
  iconMenu();
  slickInitialize();

  modalVideo();
  initGoodbye();


  setContactForm();

  $(window).on('resize', function(){
    // Trigger resize with 500 milliseconds delay
    if(typeof tm != 'undefined' && tm != null){
      clearTimeout(tm);
    }
    tm = setTimeout(function(){
      equalHeight();
    }, 500);

  });

  $(window).on('load', function(){
    equalHeight();


  });






  window.onload = function() {
    setTimeout(function() {

      easyload();

    }, 300);
  };



})(jQuery); // Fully reference jQuery after this point.




// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);




function isHighDensity(){
  return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
}

function isRetina(){
  return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}
